import store from '@/features/common/store';

export async function generateEventData() {
  const userInfo = store.getters.getUserInfo;
  const serverMode = process.env.VUE_APP_SERVER_MODE || 'dev';
  const envMap = { live: 'production', test: 'test' };

  return {
    user_id: String(userInfo.userId),
    timestamp: new Date().toISOString(),
    send_to: process.env.VUE_APP_GA_MEASUREMENT_ID || '',
    environment: envMap[serverMode] || 'development',
  };
}

export async function trackEvent(gtag, action, data) {
  const eventDate = await generateEventData();

  if (typeof gtag !== 'undefined') {
    gtag.event(action, { ...data, ...eventDate });
  }
}

export async function setGA4Environment(gtag) {
  if (typeof gtag === 'undefined') return;

  const isLiveMode = process.env.VUE_APP_SERVER_MODE === 'live';
  gtag.set('environment', isLiveMode ? 'production' : 'development');
}
